import { VarietyService } from '../../../../../shared/recommendation/services/variety.service'
import { LoadingState } from '../../../../../state/loading/loading.reducer'
import { startLoadingVarieties, stopLoadingVarieties } from '../../../../../state/loading/loading.actions'
import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { catchError, distinctUntilChanged, map, mergeMap, of, tap } from 'rxjs'
import { loadVarieties, loadVarietiesFailure, loadVarietiesSuccess } from '../actions/variety.actions'

@Injectable()
export class VarietyEffects {
  private actions$ = inject(Actions)
  private varietyService = inject(VarietyService)
  private loadingStore = inject<Store<LoadingState>>(Store)

  public getVarieties$ = createEffect(() => {
    this.loadingStore.dispatch(startLoadingVarieties())

    return this.actions$.pipe(
      ofType(loadVarieties),
      distinctUntilChanged(),
      mergeMap(() =>
        this.varietyService.getAll().pipe(
          tap(() => this.loadingStore.dispatch(stopLoadingVarieties())),
          map((varieties) => loadVarietiesSuccess({ varieties })),
          catchError((e) => {
            this.loadingStore.dispatch(stopLoadingVarieties())
            return of(loadVarietiesFailure({ error: `${e}` }))
          }),
        ),
      ),
    )
  })
}
